/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_verify_identity_approved_title = /** @type {(inputs: {}) => string} */ () => {
	return `Identidad Verificada`
};

const en_verify_identity_approved_title = /** @type {(inputs: {}) => string} */ () => {
	return `Identity Verified`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const verify_identity_approved_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.verify_identity_approved_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("verify_identity_approved_title", locale)
	if (locale === "es") return es_verify_identity_approved_title(inputs)
	return en_verify_identity_approved_title(inputs)
};
export { verify_identity_approved_title as "verify_identity.approved_title" }